import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { TextKey } from '@mews-commander/enums';
import { PortfolioRateOverview } from '@mews-commander/data-access';

export const getBulkEditVariables = (selectedRows: PortfolioRateOverview[]) => {
    const hasDependentRates = selectedRows.some((rate) => !rate.isBaseRate);
    const hasBaseRates = selectedRows.some((rate) => rate.isBaseRate);
    const hasBaseAndDependentRates = hasBaseRates && hasDependentRates;
    const areRatesDependent = hasDependentRates && !hasBaseRates;
    const ratesHaveDifferentKeys = selectedRows.some((rate) => rate.key !== selectedRows[0].key);
    const areNoRowsSelected = selectedRows.length === 0;
    const isEditDisabled = areNoRowsSelected || ratesHaveDifferentKeys || hasBaseAndDependentRates;
    const disabledEditTooltipText =
        areNoRowsSelected || ratesHaveDifferentKeys
            ? TextKey.SelectRatesWithSameKeyTooltipHint
            : TextKey.BaseAndDependentRatesMixTooltipHint;
    const selectedRateIds = pipe(
        selectedRows,
        array.map((rate) => rate.id)
    );

    const selectedPropertyIds = selectedRows.map((rate) => rate.propertyId);

    return {
        isEditDisabled,
        disabledEditTooltipText,
        areRatesDependent,
        selectedRateIds,
        selectedPropertyIds,
    };
};
